import React from "react";
import {PersonDocumentRetention, PersonDocumentRetentionRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import {types} from "../../../../components/form/types";
import {Grid} from "@mui/material";

/** Un plazo de conservación (#13996). Cambiarlo cambia la lista de documentos fuera de plazo; no borra nada. */
export const PersonDocumentRetentionEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(PersonDocumentRetentionRestControllerApiFactory);

    const form = useForm({
        fetcher: (id) => ctrl.getPersonDocumentRetention(id),
        updater: (bean) => ctrl.savePersonDocumentRetention(bean),
        remover: (id) => ctrl.deleteOrDismissPersonDocumentRetention(id),
        factory: () => {
            return {months: 48} as PersonDocumentRetention;
        },
    } as UseFormProps<PersonDocumentRetention>);

    return (
        <>
            <FormContent form={form} title={"Plazo de conservación"}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={8}>
                        <FormInput type={"text"} field={"name"} label={"Nombre"}/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormInput type={"text"} field={"treatment"} label={"Tratamiento"}
                                   helperText={"Del registro de tratamientos: T-01, T-03…"}/>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <FormSelect field={"type"} type={types.personDocumentTypes} label={"Tipo de documento"} displayEmpty
                                    helperText={"Vacío: todos los tipos"}/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormSelect field={"basis"} type={types.retentionBases} label={"Desde cuándo corre"}/>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormInput type={"number"} field={"months"} label={"Meses"}/>
                    </Grid>
                </Grid>

                <FormInput type={"text"} field={"description"} label={"Motivo"} rows={3}/>
            </FormContent>
        </>
    );
};
